import { render, staticRenderFns } from "./viscerachart.vue?vue&type=template&id=68aee425&scoped=true&"
import script from "./viscerachart.vue?vue&type=script&lang=js&"
export * from "./viscerachart.vue?vue&type=script&lang=js&"
import style0 from "./viscerachart.vue?vue&type=style&index=0&id=68aee425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aee425",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68aee425')) {
      api.createRecord('68aee425', component.options)
    } else {
      api.reload('68aee425', component.options)
    }
    module.hot.accept("./viscerachart.vue?vue&type=template&id=68aee425&scoped=true&", function () {
      api.rerender('68aee425', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/physical/viscerachart.vue"
export default component.exports